import type { User, UserStats } from '@shess/schemas'

interface Props {
  user: User
  stats: UserStats | undefined
}

export function StatsBar({ user, stats }: Props) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-4 border-b border-stone-800 px-5 py-3">
      <div className="flex items-baseline gap-2">
        <span className="text-lg font-semibold tracking-tight">shess</span>
        <span className="text-sm text-stone-500">{user.username}</span>
      </div>

      <div className="flex items-center gap-5 text-sm">
        <Stat
          label="Rating"
          value={
            <>
              {stats?.rating ?? user.rating}
              {stats?.provisional ? (
                <span className="ml-1 text-xs text-amber-400" title="Still settling">
                  ?
                </span>
              ) : null}
            </>
          }
        />
        <Stat
          label="Solved"
          value={stats ? `${stats.solved}/${stats.attempted}` : '—'}
        />
        <Stat
          label="Streak"
          value={stats ? `${stats.currentStreak}` : '—'}
          hint={stats && stats.bestStreak > 0 ? `best ${stats.bestStreak}` : undefined}
        />
      </div>
    </header>
  )
}

function Stat({
  label,
  value,
  hint,
}: {
  label: string
  value: React.ReactNode
  hint?: string
}) {
  return (
    <div className="text-right">
      <div className="text-[0.65rem] uppercase tracking-wide text-stone-500">{label}</div>
      <div className="font-medium tabular-nums">
        {value}
        {hint ? <span className="ml-1 text-xs text-stone-500">{hint}</span> : null}
      </div>
    </div>
  )
}
